import { render, staticRenderFns } from "./brand-toggle.vue?vue&type=template&id=31838c5c"
import script from "./brand-toggle.vue?vue&type=script&lang=js"
export * from "./brand-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31838c5c')) {
      api.createRecord('31838c5c', component.options)
    } else {
      api.reload('31838c5c', component.options)
    }
    module.hot.accept("./brand-toggle.vue?vue&type=template&id=31838c5c", function () {
      api.rerender('31838c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/brand-toggle/brand-toggle.vue"
export default component.exports